<template>
    <div :class="getTheme">
        <div :id="getId" class="popup-filter" v-click-outside="hide">
            <div class="card-body" :key="componentKey">
                <b-row v-if="!esconderOrdenacao">
                    <b-col class="mb-0">
                        <a class="popup-filter-order" @click="sortingChanged('asc')">
                            Classificar A <i class="fas fa-long-arrow-alt-right"></i> Z
                        </a>
                    </b-col>
                </b-row>
                <b-row v-if="!esconderOrdenacao">
                    <b-col class="mt-2 mb-0">
                        <a class="popup-filter-order" @click="sortingChanged('desc')">
                            Classificar Z <i class="fas fa-long-arrow-alt-right"></i> A
                        </a>
                    </b-col>
                </b-row>
                <b-row v-if="filtro.tipo == 'texto' && filtro.mascara == null" :key="componentKey">
                    <b-col class="mt-3 mb-0">
                        <b-form-group
                                label="Filtrar o texto em:"
                                label-for="valor"
                                :key="componentKey"
                                class="text-label">
                            <b-form-select v-model="filtro.filtrarEm" class="mb-3" :key="componentKey">
                                <template v-slot:first>
                                    <option :value="null">Qualquer parte</option>
                                </template>
                                <template>
                                    <option :value="1">Início do texto</option>
                                </template>
                                <template>
                                    <option :value="2">Final do texto</option>
                                </template>
                                <template>
                                    <option :value="3">Está vazio</option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="filtro.tipo == 'texto' && filtro.filtrarEm != 3">
                    <b-col class="mt-3 mb-0">
                        <b-form-group
                                label="Filtrar pelo texto:"
                                label-for="campoTexto"
                                class="text-label">
                            <b-form-input type="text" name="campoTexto" maxlength="250" v-model="filtro.campoTexto"
                                          @keyup="enterField"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row :style="filtro.mascara != null && filtro.filtrarEm != 3 ? 'display: block;' : 'display:none;'">
                    <b-col class="mt-3 mb-0">
                        <b-form-group
                                label="Filtrar pelo valor:"
                                label-for="campoMascara"
                                class="text-label">
                            <b-form-input name="campoMascara" type="text" maxlength="250" v-model="filtro.campoMascara" @keyup="enterField"
                                          v-mask="filtro.mascara != null ? filtro.mascara : ''"
                                          v-if="filtro.mascara != 'telefone' && filtro.mascara != 'cnj'"></b-form-input>
                            <b-form-input name="campoMascara" type="text" maxlength="250" v-model="filtro.campoMascara" @keyup="enterField"
                                          v-mask="['(##) #####-####', '(##) ####-####']"
                                          v-if="filtro.mascara == 'telefone'"></b-form-input>
                            <b-form-input id="cnjFiltro" name="campoMascara" type="text" maxlength="250" v-model="filtro.campoMascara" @keyup="enterField"
                                          v-mask="['#######-##.####.#.##.####']" @change="completarCnj();"
                                          v-if="filtro.mascara == 'cnj'"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="filtro.tipo == 'data' || filtro.tipo == 'numerico' || filtro.tipo == 'dataCurta'">
                    <b-col class="mt-3 mb-0">
                        <b-form-group
                                :label="'Filtrar ' + (filtro.tipo == 'data' || filtro.tipo == 'dataCurta' ? 'a data:' : 'o valor:')"
                                label-for="valor"
                                class="text-label">
                            <b-form-select v-model="filtro.filtrarEm" class="mb-3" name="valor">
                                <template v-slot:first>
                                    <option :value="null">Igual</option>
                                </template>
                                <template>
                                    <option :value="1">Maior que</option>
                                </template>
                                <template>
                                    <option :value="3">Maior Igual a</option>
                                </template>
                                <template>
                                    <option :value="2">Menor que</option>
                                </template>
                                <template>
                                    <option :value="4">Menor Igual a</option>
                                </template>
                                <template>
                                    <option :value="5">Está vazio</option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="filtro.tipo == 'data' && filtro.filtrarEm != 5">
                    <b-col class="mt-3 mb-0">
                        <label>
                            Filtro por Data:
                        </label>
                        <b-input v-model="filtro.campoData" type="date"></b-input>
                    </b-col>
                </b-row>
                <b-row v-if="filtro.tipo == 'dataCurta' && filtro.filtrarEm != 5">
                    <b-col class="mt-3 mb-0">
                        <label>
                            Filtro por Data:
                        </label>
                        <b-form-input type="text" maxlength="7" v-model="filtro.campoData"
                                      @keyup="filtro.campoData = validarFormatoData(filtro.campoData);enterField();"
                                      @blur="filtro.campoData = validarData(filtro.campoData);"
                                      v-mask="['##/####']"></b-form-input>
                    </b-col>
                </b-row>
                <b-row v-if="filtro.tipo == 'numerico' && filtro.filtrarEm != 5">
                    <b-col class="mt-3 mb-0">
                        <b-form-group
                                :label="'Filtro por valor:'"
                                label-for="valorminparc"
                                class="text-label">
                            <money class="form-control"
                                   v-model="filtro.campoTexto"
                                   v-bind="money"
                                   @keyup="enterField"></money>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="filtro.tipo == 'radio'">
                    <b-col class="mt-3 mb-0">
                        <p>
                            Filtro por opção:
                        </p>
                        <b-form-group label>
                            <b-form-radio-group
                                    name="radio-group-9"
                                    :options="filtro.listaValores"
                                    @change="selectRadio"
                                    v-model="filtro.campoRadio"
                                    class="radio-filter">
                                <template v-slot:first>
                                    <b-form-radio :value="null">Ambos</b-form-radio>
                                </template>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="filtro.tipo == 'checkbox'">
                    <b-col class="mt-3 mb-0">
                        <p>
                            Filtro por opções:
                        </p>
                        <b-form-group label>
                            <b-form-checkbox-group
                                    name="checkboxSituacao"
                                    v-model="filtro.campoCheckbox"
                                    :value-field="filtro.campoCheckboxId || 'id'"
                                    text-field="nome"
                                    :options="filtro.listaValores"
                                    @input="changeData">
                            </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr class="mt-2 mb-2">
                <b-row class="center-xy">
                    <b-button variant="outline-info" @click="limpar">
                        <i class="fas fa-eraser" v-b-popover.hover.top="'Limpar'"></i>
                    </b-button>
                    <b-button variant="outline-secondary" style="margin: 0 10px" @click="cancelar">
                        <i class="fas fa-ban" v-b-popover.hover.top="'Cancelar'"></i>
                    </b-button>
                    <b-button variant="outline-primary" @click="ok">
                        <i class="fas fa-check-circle" v-b-popover.hover.top="'Ok'"></i>
                    </b-button>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
    import ClickOutside from 'vue-click-outside'
    import formatarMixins from '../../../mixins/formatarMixins'
    import moment from 'moment'
    import { Money } from 'v-money'

    export default {
        props: [ 'filtro', 'compId', 'esconderOrdenacao' ],
        components: {
            Money
        },
        mixins: [ formatarMixins ],
        data() {
            return {
                money: {
                    decimal: ',',
                    thousands: '.',
                    precision: 2,
                    masked: false
                },
                componentKey: 0,
                allowClose: false
            }
        },
        computed: {
            getId () {
                return this.compId ? this.compId : 'popup'
            },
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            closeFilterPopup() {
                document.getElementById(this.getId).style.display = 'none';
                this.allowClose = false;
            },
            openCloseFilterPopup (event, relative, lefRelative, topRelative) {
                var left = 0
                this.componentKey += 1;

                if (relative) {
                    left = event.pageX - lefRelative
                } else {
                    left = (event.pageX + 5);
                    if((left + 220) > window.screen.width) {
                        left = window.screen.width - 220;
                    }
                }

                document.getElementById(this.getId).style.left = left + 'px';
                document.getElementById(this.getId).style.top =  ((relative ? topRelative : event.pageY) + 5) + 'px';
                document.getElementById(this.getId).style.display = 'block';

                this.allowClose = false;

                setTimeout(()=>{
                    this.allowClose = true;
                }, 200);
            },
            hide() {
                if(this.allowClose) {
                    this.closeFilterPopup();
                }
            },
            enterField(event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                    this.closeFilterPopup();
                    this.$emit('filtrarResultados', false);
                }
            },
            changeData(event) {
                this.closeFilterPopup();
                this.$emit('filtrarResultados', false);
            },
            selectRadio(event) {
                this.filtro.campoRadio = event;
                this.closeFilterPopup();
                this.$emit('filtrarResultados', false);
            },
            ok() {
                this.closeFilterPopup();
                this.$emit('filtrarResultados', false);
            },
            cancelar() {
                this.closeFilterPopup();
            },
            limpar() {
                this.closeFilterPopup();
                this.$emit('filtrarResultados', true);
            },
            sortingChanged(order) {
                this.closeFilterPopup();
                this.$emit('ordenarResultados', order);
            },
            filtrarLocal (items, filtros) {
                /* retorna items filtrados */
                return items.filter((item) => {
                    /* a principio retornara a nao ser que seja barrado pelo filtro */
                    let match = true

                    /* utilizando every, pois se retornar false em um filtro, ja eh um match falso */
                    Object.keys(filtros).every((key) => {
                        /* caso o filtro exista */
                        if (filtros[key]) {
                            /* verificar operador por tipo de filtro */
                            if (filtros[key].filtrarEm !== undefined) {
                                /* caso seja texto */
                                if (filtros[key].tipo === 'texto') {
                                    if (filtros[key].filtrarEm === 1) { // inicio
                                        match = item[key].startsWith(filtros[key].valor)
                                    } else if (filtros[key].filtrarEm === 2) { // final
                                        match = item[key].endsWith(filtros[key].valor)
                                    } else if (filtros[key].filtrarEm === 3) { // vazio
                                        match = this.isEmpty(item[key])
                                    } else { // qualquer lugar
                                        match = item[key].includes(filtros[key].valor)
                                    }
                                }
                                /* caso seja numerico */
                                else if (filtros[key].tipo === 'numerico') {
                                    if (filtros[key].filtrarEm === 1) { // maior que
                                        match = +item[key] > +filtros[key].valor
                                    } else if (filtros[key].filtrarEm === 2) { // menor que
                                        match = +item[key] < +filtros[key].valor
                                    } else if (filtros[key].filtrarEm === 3) { // maior igual a
                                        match = +item[key] >= +filtros[key].valor
                                    } else if (filtros[key].filtrarEm === 4) { // menor igual a
                                        match = +item[key] <= +filtros[key].valor
                                    } else if (filtros[key].filtrarEm === 5) { // vazio
                                        match = this.isEmpty(item[key])
                                    } else { // igual
                                        match = +item[key] === +filtros[key].valor
                                    }
                                }
                                /* caso seja data */
                                else if (filtros[key].tipo === 'data') {
                                    if (filtros[key].filtrarEm === 1) { // maior que
                                        match = moment(item[key], 'DD/MM/YYYY') > moment(filtros[key].valor)
                                    } else if (filtros[key].filtrarEm === 2) { // menor que
                                        match = moment(item[key], 'DD/MM/YYYY') < moment(filtros[key].valor)
                                    } else if (filtros[key].filtrarEm === 3) { // maior igual a
                                        match = moment(item[key], 'DD/MM/YYYY') >= moment(filtros[key].valor)
                                    } else if (filtros[key].filtrarEm === 4) { // menor igual a
                                        match = moment(item[key], 'DD/MM/YYYY') <= moment(filtros[key].valor)
                                    } else if (filtros[key].filtrarEm === 5) { // vazio
                                        match = this.isEmpty(item[key])
                                    } else { // igual
                                        match = moment(item[key], 'DD/MM/YYYY') === moment(filtros[key].valor)
                                    }
                                }
                                else {
                                    match = `${item[key]}`.includes(filtros[key].valor)
                                }
                            } else {
                                match = `${item[key]}`.includes(filtros[key].valor)
                            }
                        }

                        return match
                    })

                    return match
                })
            },
            completarCnj() {
                if (this.filtro.campoMascara != '' && this.onlyNumber(this.filtro.campoMascara).length < 20) {
                    this.filtro.campoMascara = this.mascaraCnj(this.onlyNumber(this.filtro.campoMascara).padStart(20, '0'));
                    document.getElementById('cnjFiltro').value = this.filtro.campoMascara;
                }
            },
            validarFormatoData(data) {
                let dataValidada = '';
                if(data.length > 1 && parseInt(data.substring(0, 2)) > 12) {
                    dataValidada = '12';
                    if(data.length > 2) {
                        dataValidada += data.substring(2);
                    }
                } else {
                    dataValidada = data;
                }
                return dataValidada;
            },
            validarData(data) {
                if(data.length != 7) {
                    return null;
                } else if(parseInt(data.substring(0, 2)) <= 0 || parseInt(data.substring(0, 2)) >= 13) {
                    return null;
                } else if(parseInt(data.substring(3)) <= 0) {
                    return null;
                }
                return dataValidada;
            },
        },
        directives: {
            ClickOutside
        }
    }
</script>

<style scoped>
</style>